import { MethodsTypes, IRequestConfig } from "models/Axios";
import axios from "axios";
import Services from "./index.service";
import { IPriorityItem, IPriorityItemCreate, IPriorityItemsData } from "models/PriorityItem";

export default class PriorityItemsServices extends Services<any, any> {
  private endpoint = `${this.mafraq_url}/PriorityItem`;

  public async GetPriorityItems(
    currentPage?: number,
    pageSize?: number,
    filter?: any
  ) {
    const skip = currentPage || 0;
    const top = pageSize;
    const filterQuery = filter || undefined;
    const config: IRequestConfig<IPriorityItem> = {
      url: `${this.endpoint}/list`,
      method: MethodsTypes.get,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        top: `${top}`,
        skip: `${skip}`,
        filter: filterQuery,
      },
    };
    return await axios<IPriorityItemsData>(config).then((result) => result.data);
  }

  public async InsertPriorityItems(items: IPriorityItemCreate[]) {
    const config: IRequestConfig<IPriorityItemCreate[]> = {
      url: `${this.endpoint}/InsertPriorityItems`,
      method: MethodsTypes.post,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
        "Content-Type": "application/json",
      },
      data: items,
    };
    return await axios(config).then((result) => result.data);
  }

  public async MarkAsDeleted(items: IPriorityItem[]) {
    const formattedItems = items.map(item => ({
      ...item,
      deleted: true,
      createdDate: new Date(item.createdDate).toISOString(),
      updatedDate: new Date(item.updatedDate).toISOString()
    }));

    const config: IRequestConfig<IPriorityItem[]> = {
      url: `${this.endpoint}/UpdatePriorityItems`,
      method: MethodsTypes.post,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
        "Content-Type": "application/json",
      },
      data: formattedItems,
    };

    try {
      const result = await axios(config);
      return result.data;
    } catch (error) {
      console.error("Erro ao atualizar itens:", error);
      throw error;
    }
  }
}